<template>

      <div class="wrapper wrapper-content">
        <div class="container-fluid">
 
<div class="row">
              

<div class="row">
  <div class="col-xs-12">
    <div class="ibox m-b-md">
      <div class="ibox-title">

          
            
          

          <h5><a class="text-primary-new" onclick="window.history.back()">รายการโพย</a> / #{{ order_number }} - {{ round_desc }}</h5>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover no-margins">
            <thead>
              <tr><th width="100">ลำดับ</th>
              <th>ประเภทหวย</th>
              <th>เลขที่แทง</th>
              <th class="text-right">   ราคาที่แทง</th>
              <th class="text-right">ราคาจ่าย</th>
              <th class="text-center">เลขที่ออก</th>
              <th class="text-right">ผลได้เสีย</th>
              <th class="text-center">สถานะ</th>
            </tr></thead>
            <tbody>
              
              <tr v-for="(item, index) in orderitem" :key="index">
                <td>{{ index+1 }}</td>
                <td>{{ bettypeTextMapping[item.bettype_id] }}</td>
                <td>{{ mappingNumber(item.number, item.bettype_id) }}</td>
                <td class="text-right">{{ formatMoney(item.bet_value) }}</td>
                <td class="text-right">{{ formatMoney(item.rate) }}</td>
                <td class="text-center">{{ lotto_result[bettypeResultMapping[item.bettype_id]] }}</td>
                <td class="text-right">
                    <div class="text-green" v-if="item.oi_win > 0">{{ formatMoney(item.win_price) }}</div>
                    <div v-else>0.00</div>
                </td>
                <td class="text-center" v-html="getItemStatus(item.status_id)">
                </td>
              </tr>

            </tbody>
            <tfoot v-if="calculateTotalBet > 0">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">รวม   {{ calculateTotalBet }}</td>
                <td class="text-right"></td>
                <td class="text-center"></td>
                <td class="text-right">
                  <span class="text-navy"><strong>+0</strong></span>
                </td>
                <td class="text-center"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

            </div>

        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'transaction',
    data () {
        return {
            orderitem: [],
            order_number: 0,
            round_desc: '',
            lotto_result: {},

            hilowMapping:{
                '55999': 'สามตัวบน',
                '55599': 'สองตัวบน',
                '55500': 'สองตัวล่าง',
            },
            evenoddMapping:{
                '55559': 'บน',
                '55550': 'ล่าง',
            },
            bettypeTextMapping: {
                4: 'สามตัวบน',
                1: 'สามตัวโต๊ด',
                2: 'สามตัวหน้า',
                3: 'สามตัวหลัง',
                5: 'สามตัวล่าง', //TODO: not implement yet
                6: 'สองตัวบน',
                7: 'สองตัวล่าง',
                8: 'วิ่งบน',
                9: 'วิ่งล่าง',
            },
            bettypeResultMapping: {
                4: 'threetop',
                1: 'threemix',
                2: 'threefront',
                3: 'threedown',
                5: 'threeback', //TODO: not implement yet
                6: 'twotop',
                7: 'twodown',
                8: 'runtop',
                9: 'rundown',
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        calculateTotalBet: function() {
            
            var betvaluetot = 0
            for (let i = 0; i < this.orderitem.length; i++) {
                betvaluetot = parseFloat(betvaluetot) + parseFloat(this.orderitem[i].betvalue)  
            }
            //console.log('betvaluetot: '+ betvaluetot)
            return betvaluetot.toFixed(2)
        },
    },
    methods: {
        async loadTransaction () {
            try {
                //console.log('order id:', this.$route.query.orderId)
                const response = await this.$store.dispatch('orderitem/getOrderitem', this.$route.query.orderId)
                //console.log('response: ', response[0])

                if ( response.length > 0 ) {
                    this.order_number = response[0].oh_ordnum
                    this.round_desc   = response[0].description

                    // get result if order status is paid or closed
                    if ( response[0].oh_status > 4 ) {

                        //console.log('response[0].oh_created', response[0].oh_created)

                        let date_result = moment( response[0].oh_created ).format('YYYY-MM-DD')
                        //console.log('date_result1', date_result)

                        // if downjones index lotto, need special check
                        if ( response[0].lottotype_id == 3 && response[0].round_id == 113 ) {

                            let date_create = moment( response[0].oh_created ).format('YYYY-MM-DD')

                            let start_time = moment(date_create + ' ' + '00:00')
                            let end_time   = moment(date_create + ' ' + '02:00')

                            //console.log('start_time', start_time)
                            //console.log('end_time', end_time)

                            if ( moment(response[0].oh_created).isBetween(start_time, end_time) ) {
                                // create between 00:00 <=> 02:00
                                // date result = today
                                date_result = date_create

                            }
                            else {
                                // create between 03:00 <=> 23:59
                                // date result = tomorrow
                                date_result = moment( response[0].oh_created).add(1, 'days').format('YYYY-MM-DD')
                            }

                        }
                        else if ( response[0].lottotype_id == 4 && response[0].round_id > 97 ) {
                            // yeekee lotto and round > 72
                            let date_create = moment( response[0].oh_created ).format('YYYY-MM-DD')

                            let start_time = moment(date_create + ' ' + '00:00')
                            let end_time   = moment(date_create + ' ' + '03:45')

                            //console.log('start_time', start_time)
                            //console.log('end_time', end_time)

                            if ( moment(response[0].oh_created).isBetween(start_time, end_time) ) {
                                // create between 00:00 <=> 03:45
                                // date result = yesterday
                                date_result = moment( response[0].oh_created).subtract(1, 'days').format('YYYY-MM-DD')

                            }
                            else {
                                // create between 05:45 <=> 23:59
                                // date result = today
                                date_result = date_create
                            }
                        }
                        //console.log('date_result2', date_result)

                        let result_query = {
                            lottotype_id: response[0].lottotype_id,
                            round_id: response[0].round_id,
                            date_result: date_result
                        }

                        const result_response = await this.$store.dispatch('lottoresult/getLottoResult', result_query)
                        //console.log('result_response', result_response)
                        this.lotto_result = result_response
                    }


                    this.orderitem    = response
                }
                
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },
        formatDate (value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
            }
        },
        mappingNumber (num, type) {

            if (type == 'evenbet' || type == 'oddbet') {
                return this.evenoddMapping[num]
            }
            else if (type == 'hibet' || type == 'lowbet') {
                return this.hilowMapping[num]
            }
            else {
                return num
            }
        },

        getItemStatus (status) {
            //console.log('status', status)
            let msgStatus = ''
            if ( status == '3' ) {
                //cancel
                msgStatus = '<span class="label label-danger">ยกเลิก</span>'
            }
            else if ( status == '4' ) {
                //complete
                msgStatus = '<span class="label label-success">รับแทง</span>'
            }
            else if ( status == '5' ) {
                //paid
                msgStatus = '<span class="label label-warning-light">ชนะเดิมพัน</span>'
            }
            else if ( status == '6' ) {
                //paid
                msgStatus = '<span class="label label-primary">ไม่ถูกรางวัล</span>'
            }
            return msgStatus
        },

        formatMoney(num) {
            if (num) {
                num = num.toFixed(2)
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

    },
    mounted () {
    },
    created () {
        //this.ordernumber = this.$route.query.orderId
        this.loadTransaction()
        //console.log('orderhead', this.orderhead)
    },
    destroyed () {
    }
}
</script>

<style lang="sass" scoped>
</style>
